module.exports = __webpack_public_path__ + "Flag-882.3ba45acf343d83d9713c871865c0e2a4.svg";